import { createContext } from "react";

export const ShiftListContext = createContext<any>(null);
